import { call } from "typed-redux-saga";

import { DataProvider } from "@com.mgmtp.a12.client/client-core/lib/core/data";
import {
	ProvideDataParams,
	ProvideDataResults,
	TreeEngineServerConnectorFactories
} from "@com.mgmtp.a12.treeengine/treeengine-core/lib/extensions/server-connector";

import { TEXTBAUSTEINE_READONLY_TREE, TEXTBAUSTEINE_TREE } from "../../utilities/variables/documentModelName";

import { handleMutations } from "./textbausteinHandleMutations";
import { handleQueries } from "./textbausteinHandleQueries";

const treeEngineDataProvider = TreeEngineServerConnectorFactories.createDataProvider({
	dataLoader: {
		*provideData(params: ProvideDataParams): ProvideDataResults {
			const mutationResults = yield* call(handleMutations, params);
			const queryResults = yield* call(handleQueries, params);

			return { queryResults, mutationResults };
		}
	},
	preloadChildNodes: true,
	cancelChildActivity: false
});

/**
 * TODO: Deep nested initial subfolders
 * TODO: Delete recursively
 */
export const textbausteinTreeDataProvider: DataProvider = {
	name: "TextbausteinTreeDataProvider",
	canHandle(config: DataProvider.CanHandleConfig) {
		const model = config.dataHolder.descriptor.model;
		if (model) {
			return model === TEXTBAUSTEINE_TREE || model === TEXTBAUSTEINE_READONLY_TREE;
		}
		return treeEngineDataProvider.canHandle(config);
	},
	*provideData(config) {
		yield* call(treeEngineDataProvider.provideData, config);
	}
};
